import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEraserSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"eraser-simple, rubber, clean-up"} maskId="square-filled-radius-0-stroke-1-IconEraserSimple"><path d="M6.50008 9.79297L14.5001 1.79297L22.2072 9.50008L14.2072 17.5001L6.50008 9.79297Z" fill="currentColor"/><path d="M5.79297 10.5001L1.79297 14.5001L9.50008 22.2072L13.5001 18.2072L5.79297 10.5001Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconEraserSimple;
